import React from 'react'
import { useParams } from 'react-router-dom'

import { components } from 'cng-web-lib'

import FormProperties from './PingEventCodeLink_FormProperties'
import PingEventCodeLinkApiUrls from 'src/apiUrls/ping/PingEventCodeLinkApiUrls'

const { form: { CngViewForm } } = components

function ViewPage({ history, showNotification }) {

	const { id } = useParams()

	//* return JSX -------------------------------------------------------------
	return (

		//* Start JSX ----------------------------------------------------------
		<CngViewForm
			fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
			history={history}
			showNotification={showNotification}
			bodySection={
				<FormProperties.Fields
					disabled={true}
					showNotification={showNotification}
					id={id}
				/>
			}
			formikProps={FormProperties.formikProps}
			toClientDataFormat={FormProperties.toClientDataFormat}
			toServerDataFormat={FormProperties.toServerDataFormat}
			fetch={{
				url: PingEventCodeLinkApiUrls.GET,
				id: id
			}}
		/>
		//* End JSX ------------------------------------------------------------

	);
	//* End of function --------------------------------------------------------
}

export default ViewPage